<template>
    <div>
        <button class="d-none" @click="openModal()" id="openInspection">open</button>

        <div class="modal fade" id="addInspectionModal" tabindex="-1" aria-labelledby="addInspectionModal"
            aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Nouvel OT</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>


                    <div class="modal-body">
                        <div class="form-group">
                            <label for="company_name">Client</label>
                            <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control"
                                id="companySearchInput" type="text" v-model="company">
                        </div>

                        <div class="form-group">
                            <label for="equipment_name" class="required">Matériel</label>
                            <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control"
                                id="equipmentSearchInput" type="text" v-model="equipment">
                        </div>

                        <div v-show="selectedEquipment && selectedEquipment != null">
                            <div class="form-group"
                                v-show="selectedEquipment && selectedEquipment != null && selectedEquipment.preventives && selectedEquipment.preventives.length > 0">
                                <label for="preventive_name">Gamme opératoire</label>
                                <input placeholder="Commencer la saisie pour obtenir des suggestions .."
                                    :disabled="selectedAsking && selectedAsking != null" class="form-control"
                                    id="preventiveSearchInput" type="text" v-model="preventive">
                            </div>

                            <div class="alert alert-warning"
                                v-if="selectedEquipment && selectedEquipment != null && selectedEquipment.preventives && selectedEquipment.preventives.length == 0">
                                Aucune gamme opératoire disponible pour ce matériel
                            </div>

                            <div class="form-group"
                                v-show="selectedEquipment && selectedEquipment != null && selectedEquipment.askings && selectedEquipment.askings.length > 0">
                                <label for="asking_number">Demande d'ordre de travaux</label>
                                <input placeholder="Commencer la saisie pour obtenir des suggestions .."
                                    :disabled="selectedPreventive && selectedPreventive != null" class="form-control"
                                    id="askingSearchInput" type="text" v-model="asking">
                            </div>

                            <div class="alert alert-warning"
                                v-if="selectedEquipment && selectedEquipment != null && selectedEquipment.askings && selectedEquipment.askings.length == 0">
                                Aucune demande d'OT disponible pour ce matériel
                            </div>

                        </div>

                    </div>
                    <div class="modal-footer">
                        <button id="btn_add_ot" type="submit" class="ix-btn green" :disabled="!checkForm()" @click="save()">
                            <span v-if="!loading">Ajouter</span>
                            <span v-if="loading"><i class="far fa-circle-notch fa-spin"></i></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CreateInspectionComponent',
    props: ['companyUrl','equipmentUrl', 'preventiveUrl', 'askingUrl', 'storeInspection'],
    data() {
        return {
            company: null,
            selectedCompany: null,
            equipment: null,
            selectedEquipment: null,
            preventive: null,
            selectedPreventive: null,
            asking: null,
            selectedAsking: null,
            loading: false,
        }
    },
    methods: {
        checkForm: function () {
            return this.selectedEquipment != null && this.selectedPreventive != null || this.selectedEquipment != null && this.selectedAsking != null;
        },
        openModal: function () {
            this.selectedEquipment = null;
            this.equipment = null;
            this.resetForm();
            $('#addInspectionModal').modal()
        },
        resetForm: function () {
            this.preventive = null;
            this.asking = null;
            this.selectedPreventive = null;
            this.selectedAsking = null;
        },
        save: function () {
            this.loading = true;
            fetch(this.storeInspection, {
                ...{
                    method: 'POST'
                },
                ...this.getHttpJsonRequestHeaders(),
                ...{
                    body: JSON.stringify({
                        'equipment_id': this.selectedEquipment.id,
                        'preventive_id': this.selectedPreventive && this.selectedPreventive != null ? this.selectedPreventive.id : null,
                        'asking_id': this.selectedAsking && this.selectedAsking != null ? this.selectedAsking.id : null,
                    })
                }
            }).then((response) => {
                if (response.status == 200) {
                    response.json().then((data) => {
                        if (data) {
                            window.location.reload();
                        }
                    })
                }
                this.loading = false;
            }).catch((error) => {
                this.loading = false;
            });
        }
    },
    mounted() {
        $("#companySearchInput").autocomplete({
            minLength: 0,
            source: (request, response) => {
                $.ajax({
                    url: this.companyUrl,
                    type: 'get',
                    dataType: 'json',
                    headers: this.getHttpJsonRequestHeaders().headers,
                    data: { q: request.term },
                    success: (data) => {
                        response($.map(data, (item) => {
                            if (this.selectedEquipment != null){
                                this.selectedEquipment = null;
                                this.equipment = null;
                            }
                            return Object.assign(item, {
                                label: item.name,
                                value: item.name
                            })
                        }))
                    }
                });
            },
            change: (e, item) => {
                if (!item.item) {
                    $(e.target).val("");
                    this.selectedCompany = null;
                    this.company = null;
                }
            },
            search: (e, item) => {
                if ($(e.target).val() == '' || $(e.target).val() == null) {
                    this.selectedCompany = null;
                    this.company = null;
                }
            },
            select: (e, item) => {
                if (item.item) {
                    this.company = item.item.name;
                    this.selectedCompany = item.item;
                }
            }
        }).focus(() => {
            $("#companySearchInput").autocomplete("search", '');
        });

        $("#equipmentSearchInput").autocomplete({
            minLength: 0,
            source: (request, response) => {
                $.ajax({
                    url: this.equipmentUrl,
                    type: 'get',
                    dataType: 'json',
                    headers: this.getHttpJsonRequestHeaders().headers,
                    data: { q: request.term },
                    success: (data) => {
                        response($.map(data, (item) => {
                            //Si le champ client est rempli, on filtre les équipements par rapport à ce client
                            if (this.selectedCompany != null) {
                                if ( item.company && item.company.id == this.selectedCompany.id) {
                                    return Object.assign(item, {
                                        label: item.name,
                                        value: item.name
                                    })
                                }
                            }
                            else {
                                return Object.assign(item, {
                                    label: item.name,
                                    value: item.name
                                })
                            }
                        }))
                    }
                });
            },
            change: (e, item) => {
                if (!item.item) {
                    $(e.target).val("");
                    this.selectedEquipment = null;
                    this.equipment = null;
                    this.resetForm();
                }
            },
            search: (e, item) => {
                if ($(e.target).val() == '' || $(e.target).val() == null) {
                    this.selectedEquipment = null;
                    this.equipment = null;
                    this.resetForm();
                }
            },
            select: (e, item) => {
                if (item.item) {
                    this.resetForm();
                    this.equipment = item.item.label;
                    this.selectedEquipment = item.item;
                }
            }
        }).focus(() => {
            $("#equipmentSearchInput").autocomplete("search", '');
        });

        $("#preventiveSearchInput").autocomplete({
            minLength: 0,
            source: (request, response) => {
                $.ajax({
                    url: this.preventiveUrl,
                    type: 'get',
                    dataType: 'json',
                    headers: this.getHttpJsonRequestHeaders().headers,
                    data: { q: request.term, 'equipment_id': this.selectedEquipment != null ? this.selectedEquipment.id : null, is_workable: true },
                    success: (data) => {
                        response($.map(data, (item) => {
                            return Object.assign(item, {
                                label: item.designation,
                                value: item.designation
                            })
                        }))
                    }
                });
            },
            change: (e, item) => {
                if (!item.item) {
                    $(e.target).val("");
                    this.selectedPreventive = null;
                    this.preventive = null;
                }
            },
            search: (e, item) => {
                if ($(e.target).val() == '' || $(e.target).val() == null) {
                    this.selectedPreventive = null;
                    this.preventive = null;
                }
            },
            select: (e, item) => {
                if (item.item) {
                    this.preventive = item.item.designation;
                    this.selectedPreventive = item.item;
                }
            }
        }).focus(() => {
            $("#preventiveSearchInput").autocomplete("search", '');
        });

        $("#askingSearchInput").autocomplete({
            minLength: 0,
            source: (request, response) => {
                
                $.ajax({
                    url: this.askingUrl,
                    type: 'get',
                    dataType: 'json',
                    headers: this.getHttpJsonRequestHeaders().headers,
                    data: { q: request.term, 'equipment_id': this.selectedEquipment != null ? this.selectedEquipment.id : null },
                    success: (data) => {
                        response($.map(data, (item) => {
                            return Object.assign(item, {
                                label: item.number,
                                value: item.number
                            })
                        }))
                    }
                });
            },
            change: (e, item) => {
                if (!item.item) {
                    $(e.target).val("");
                    this.selectedAsking = null;
                    this.asking = null;
                }
            },
            search: (e, item) => {
                if ($(e.target).val() == '' || $(e.target).val() == null) {
                    this.selectedAsking = null;
                    this.asking = null;
                }
            },
            select: (e, item) => {
                if (item.item) {
                    this.asking = item.item.number;
                    this.selectedAsking = item.item;
                }
            }
        }).focus(() => {
            $("#askingSearchInput").autocomplete("search", '');
        });
    }
}
</script>